import React from 'react';
import ModalWrapper from '../ModalWrapper/ModalWrapper';
import ProductsListForCreationPopup from '../ProductsListForCreationPopup/ProductsListForCreationPopup';
import {ProductInDepotType} from '../../types/ProductSliceTypes';
import s from './CreatePopupBase.module.css';

type CreatePopupBaseProps = {
	close: () => void;
	prepareProducts: ProductInDepotType[];
	changeProductCallback: (
		id: string,
		action: '+' | '-' | 'manual' | 'remove',
		value?: number,
	) => void;
	children: React.ReactNode;
	showProductsList?: boolean;
	className?: string;
};

/**
 * Базовый компонент для попапов создания/редактирования (накладных, оформлений и т.д.)
 * Предоставляет общую структуру с ModalWrapper и списком продуктов
 * 
 * @param close - функция закрытия попапа
 * @param prepareProducts - массив продуктов для отображения
 * @param changeProductCallback - функция изменения количества продуктов
 * @param children - дочерние элементы (формы, кнопки и т.д.)
 * @param showProductsList - показывать ли список продуктов (по умолчанию true)
 * @param className - дополнительные CSS классы
 * 
 * @example
 * <CreatePopupBase
 *   close={handleClose}
 *   prepareProducts={products}
 *   changeProductCallback={handleChange}
 * >
 *   <div className={s.blockWrapper}>
 *     <FindDistributorsComponent client={client} setClient={setClient} />
 *   </div>
 *   <div className={s.buttonsContainer}>
 *     <LightGreenButton text="Сохранить" type="submit" />
 *   </div>
 * </CreatePopupBase>
 */
const CreatePopupBase: React.FC<CreatePopupBaseProps> = ({
	close,
	prepareProducts,
	changeProductCallback,
	children,
	showProductsList = true,
	className = '',
}) => {
	return (
		<ModalWrapper handleClosePopup={close}>
			<div className={`${s.container} ${className}`}>
				{showProductsList && (
					<ProductsListForCreationPopup
						close={close}
						changeProductCallback={changeProductCallback}
						prepareProducts={prepareProducts}
					/>
				)}
				{children}
			</div>
		</ModalWrapper>
	);
};

export default CreatePopupBase;

